import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { faAngleRight, faEnvelope, faHome, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import Swal from "sweetalert2";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  sendmessage = new FormGroup({
    FirstName: new FormControl('', Validators.required),
    LastName: new FormControl('', Validators.required),
    Phone: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    message: new FormControl('', Validators.required),
  });

  submitted = false;
  faHome = faHome;
  isLoading = false;
 faAngleRight =  faAngleRight;
 faInfoCircle = faInfoCircle
 faEnvelope = faEnvelope
  constructor(
    private formBuilder: FormBuilder,
    public translate : TranslateService,
    private router: Router,
    private http: HttpClient
  ) { 
      const gtmTag = {
        event: 'Page View',
        pageName: 'Contact Us',
        language: this.translate.currentLang, 
        url:this.router.url
      };
     
    } 

  ngOnInit() {
  }
  get f() { return this.sendmessage.controls; }


  onSubmit() {
    console.log(this.sendmessage.get('FirstName'))
    console.log(this.sendmessage.value)
    this.submitted = true;

    // stop here if form is invalid
    if (this.sendmessage.invalid) {
      return;
    }

    this.sendMessageRequest();
  }

  sendMessageRequest() {
    this.isLoading = true;

    const body = {
      "EmailBody": this.sendmessage.get('message').value,
      "EmailAddress": this.sendmessage.get('email').value,
      "Subject": this.sendmessage.get('message').value
    }

    this.http.post('https://trncms.round-pixel.net/api/ContactUs', body).subscribe({
      next: () => {
        this.isLoading = false;
        Swal.fire({
          title: this.translate.currentLang === 'en' ? "Sent Successfully" : "تم الإرسال بنجاح",
          icon: 'success',
        })
        this.router.navigate(['/']);
      }, 
      error: () => {
        this.isLoading = false;
        Swal.fire({
          title: this.translate.currentLang === 'en' ? "Try Again" : "حاول مره إخري",
          icon: 'error',
        })
        this.router.navigate(['/']);
      }
    })
  }

  onReset() {
    this.submitted = false;
    this.sendmessage.reset();
  }

}